import { render, staticRenderFns } from "./pageRoute.vue?vue&type=template&id=03dec851&scoped=true"
import script from "./pageRoute.vue?vue&type=script&lang=js"
export * from "./pageRoute.vue?vue&type=script&lang=js"
import style0 from "./pageRoute.vue?vue&type=style&index=0&id=03dec851&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dec851",
  null
  
)

export default component.exports